import { Routes, Route } from 'react-router-dom';
import PortalLayout from "../../layouts/PortalLayout";
import Dashboard from "../dashboard/Dashboard";
import GroupReports from "../groupReports/GroupReports";
import ManageTutors from "../manageTutors/ManageTutors";
import ManageUsers from "../manageUsers/ManageUsers";
import ManageTutorGroups from "../manageTutorGroups/ManageTutorGroups";
import ManageSchools from "../manageSchools/ManageSchools";
import ManageStudents from '../manageStudents/ManageStudents';
import RoadmapsReport from "../roadmapsReport/RoadmapsReport";
import Students from "../students/Students";
import AllStudents from "../allStudents/AllStudents";


const Portal = () => {

    return (
        <>
            <PortalLayout>
                <Routes>
                    <Route path="students/all-students" element={<AllStudents />} />
                    <Route path="students/*" element={<Students />} />

                    {/*  Reporting */}
                    <Route path="/group-reports" element={<GroupReports />} />
                    <Route path="/roadmaps" element={<RoadmapsReport />} />

                    {/* Admin */}
                    <Route path="/manage-tutors" element={<ManageTutors />} />
                    <Route path="/manage-users" element={<ManageUsers />} />
                    <Route path="/manage-tutor-groups" element={<ManageTutorGroups />} />
                    <Route path="/manage-schools" element={<ManageSchools />} />
                    <Route path="/manage-students" element={<ManageStudents />} />
                    <Route path="/" element={<Dashboard />} />
                </Routes>
            </PortalLayout>
        </>
    );
}

export default Portal;